import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Ab wann hat Julia eine Verbesserung bemerkt?',
  answer: 'Bereits nach 7–10 Tagen zeigte Oscar deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
}, {
  question: 'Ist das Topping auch für empfindliche Hunde geeignet?',
  answer: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
}, {
  question: 'Wie viel gibt man täglich?',
  answer: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Julia hat mit der kleinsten Menge angefangen und langsam gesteigert.'
}, {
  question: 'Was wenn es bei meinem Hund nicht wirkt?',
  answer: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-16" style={{
    backgroundColor: 'var(--color-cream-dark)'
  }} data-id="element-49">
      <div className="max-w-3xl mx-auto px-4" data-id="element-50">
        <h3 className="font-handwritten text-3xl md:text-4xl text-center mb-10" style={{
        color: 'var(--color-green)'
      }} data-id="element-51">
          Häufige Fragen
        </h3>
        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl overflow-hidden border" style={{
          borderColor: 'var(--color-border)'
        }} data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-54">
                <span className="font-semibold" style={{
              color: 'var(--color-text)'
            }} data-id="element-55">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} style={{
              color: 'var(--color-brown)'
            }} data-id="element-56" />
              </button>
              <AnimatePresence data-id="element-57">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58">
                    <div className="px-6 pb-4 text-sm leading-relaxed" style={{
                color: 'var(--color-text-light)'
              }} data-id="element-59">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}